import React, { useState, useEffect  } from 'react';
import './Afrekenen.css';
import { loadStripe } from '@stripe/stripe-js';
import {
  Elements,
} from '@stripe/react-stripe-js';
import { AfrekenFormulier } from './AfrekenFormulier'
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom';

type Props = {}

  const stripePromise = loadStripe("pk_live_51S7F4PGXMXqKTnd0gcu01idzZaEBTVtfpOoB13jf8XJcCooC721b5GlNl2Ohj4HeEX4fh4SzXCsV2QkIKITIarfm00mYdgr3iu");

const Afrekenen = (props: Props) => {
  const { state } = useLocation();
  const [cart, setCart] = useState([]);
  const [total, setTotal] = useState(0);
    const navigate = useNavigate();


  const [clientSecret, setClientSecret] = useState("");

  if (!state || !state.total || state.total === 0) {
    navigate('/');
  }
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    fetch("/.netlify/functions/server/create-payment-intent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ bestelling: {
      naam: state.naam,
      voornaam: state.voornaam,
      email: state.email,
      telefoon: state.telefoon,
      opnaamvan: state.opnaamvan,
      levermethode: state.levermethode,
      aantal: state.aantal
      } }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, []);

  
  const goToConfirmationPage = () => {
    navigate('/confirmatie', {state: {
      cart,
    }});
  }

  const appearance = {
    theme: 'stripe',
  };
  // Enable the skeleton loader UI for optimal loading.
  const loader = 'auto';

  return (
    <div className="Afrekenen">
      <span>Te betalen: €{state.total},00</span>
      {clientSecret && (
      <Elements stripe={stripePromise} options={{clientSecret, appearance, loader}} >
        <AfrekenFormulier />
      </Elements>
      )}
    </div>
  );
}

export default Afrekenen;
